import SettingsSectionSidebar from '@/components/Settings/SettingsSectionSidebar'

/**
 * @param {{ activeSectionId: string, onSectionSelect: (sectionId: string) => void }} props
 */
export default function SettingsSectionView({ activeSectionId, onSectionSelect }) {
  return <SettingsSectionSidebar activeSectionId={activeSectionId} onSectionSelect={onSectionSelect} />
}
